import { useMemo } from "react";
import { MantineProvider, type MantineColorScheme } from "@mantine/core";
import { NodusTheme, createBrandedTheme, type NodusBranding } from "./theme";

export interface NodusProviderProps {
  children: React.ReactNode;
  /** Site branding — primary/secondary colors override the default Nodus theme */
  branding?: NodusBranding | null;
  /** Color scheme: light, dark, or auto (system preference) */
  colorScheme?: MantineColorScheme;
}

export function NodusProvider({
  children,
  branding,
  colorScheme = "auto",
}: NodusProviderProps) {
  const theme = useMemo(
    () => (branding?.primaryColor ? createBrandedTheme(branding) : NodusTheme),
    [branding?.primaryColor, branding?.secondaryColor],
  );

  return (
    <MantineProvider theme={theme} defaultColorScheme={colorScheme}>
      {children}
    </MantineProvider>
  );
}
